module.exports = __webpack_public_path__ + "static/img/slide1.ce00b50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/old/slide1.jpg
// module id = hn1k
// module chunks = 0